(function() {
  angular
    .module('specsguardApp')
    .controller('mAreaItemCtrl', mAreaItemCtrl);

  mAreaItemCtrl.$inject = ['$scope', 'Labels', 'Project', 'ProjectBusinessService',
  'errorMessageService', 'sgAreaInheritanceHelpers', 'filterModuleFactory', '$timeout', '$injector'];

  function mAreaItemCtrl($scope, Labels, ProjectAPI, ProjectBusinessService,
    errorMessageService, sgAreaInheritanceHelpers, filterModuleFactory, $timeout, $injector) {

    const vm = this;
    vm.LABELS = Labels;
    vm.elementIdentifier = 0;
    vm.elements = [];
    vm.selectedElements = [];

    vm.customValues =  {
      constructionId: $scope.area._id
    };

    vm.elementViewType = ( isCustom ) => {
      return isCustom ? 'area' : 'basicArea';
    };

    vm.getElements = ( module, submodule ) => {
      const { moduleId } = module;
      const { submoduleId } = submodule;
      let elements;

      // Based on the moduleId & submoduleId we can fetch the elements from the area.mods
      $scope.area.mods.filter(mod => {
        if (mod._id === moduleId) {
          mod.submodules.filter(subMod => {
            if ( subMod._id === submoduleId ) {
              subMod.elements.filter(element => {
                element.customValues = vm.customValues;
                element.model = {
                  moduleId,
                  submoduleId,
                  area: $scope.area._id,
                };
              });

              elements = Object.assign([{}], subMod.elements);
            }
          });
        }
      });

      return elements;
    };

  }
})();
